'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;

var _mobx = require('mobx');

var _reactDom = require('react-dom');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _simulationEntity = require('simulation-entity');

var _roundEntity = require('round-entity');

var _taskEntity = require('task-entity');

var _teamstateEntity = require('teamstate-entity');

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _mixwith = require('mixwith');

var _layoutComponent = require('layout-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var FlowEditorViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.observable.ref, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, _dec13 = _mobx.action.bound, _dec14 = _mobx.action.bound, _dec15 = _mobx.action.bound, _dec16 = _mobx.action.bound, _dec17 = _mobx.action.bound, _dec18 = _mobx.action.bound, _dec19 = _mobx.action.bound, _dec20 = _mobx.action.bound, _dec21 = _mobx.action.bound, _dec22 = _mobx.action.bound, _dec23 = _mobx.action.bound, _dec24 = _mobx.action.bound, _dec25 = _mobx.action.bound, _dec26 = _mobx.action.bound, _dec27 = _mobx.action.bound, _dec28 = _mobx.action.bound, _dec29 = _mobx.action.bound, _dec30 = _mobx.action.bound, _dec31 = _mobx.action.bound, _dec32 = _mobx.action.bound, _dec33 = _mobx.action.bound, _dec34 = _mobx.action.bound, _dec35 = _mobx.action.bound, _dec36 = _mobx.action.bound, _dec37 = _mobx.action.bound, _dec38 = _mobx.action.bound, _dec39 = _mobx.action.bound, _dec40 = _mobx.action.bound, _dec41 = _mobx.action.bound, _dec42 = _mobx.action.bound, _dec43 = _mobx.action.bound, _dec44 = _mobx.action.bound, _dec45 = _mobx.action.bound, _dec46 = _mobx.action.bound, (_class = function (_mix$with) {
  (0, _inherits3.default)(FlowEditorViewStore, _mix$with);
  (0, _createClass3.default)(FlowEditorViewStore, [{
    key: 'handleDeleteRound',
    // Used to track what element to scroll to when expanding...
    value: function handleDeleteRound(event, roundIndex) {
      var _this2 = this;

      this.props.modalViewStore.setModal({
        title: 'Delete Round',
        message: 'Are you sure you want to delete "' + this.simulation.rounds[roundIndex].displayName + '"?',
        confirmLabel: 'Confirm',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          _this2.deleteRound(event, roundIndex);_this2.props.modalViewStore.resetModal();
        }
      });
    }
  }, {
    key: 'permanentlyDeleteTask',
    value: function permanentlyDeleteTask(task) {
      var _this3 = this;

      var activity = task.activity;
      task.deleteEntity(function () {
        return activity && activity._deleteEntity && activity._deleteEntity();
      }, null, { onConfirmImmediate: function onConfirmImmediate() {
          return _this3.taskPickerActiveTask = null;
        } });
      this.removeTaskFromQue(task.id);
    }
  }, {
    key: 'cloneTask',
    value: function cloneTask(task) {
      task.cloneEntity(null, null, {
        cloneChildren: true
      });
    }
  }, {
    key: 'handleDeleteAllRounds',
    value: function handleDeleteAllRounds(event) {
      var _this4 = this;

      var listAllRounds = function listAllRounds() {
        return _this4.simulation.rounds.map(function (round, roundIndex) {
          return _react2.default.createElement(
            'div',
            { className: 'round-display-title', key: roundIndex },
            round.displayName
          );
        });
      };

      this.props.modalViewStore.setModal({
        title: 'Delete All Rounds',
        message: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'sub-title' },
            'Are you sure you want to delete all rounds in this simulation?'
          ),
          _react2.default.createElement(
            'div',
            null,
            listAllRounds()
          )
        ),
        confirmLabel: 'Confirm',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          _this4.deleteAllRounds(event);_this4.props.modalViewStore.resetModal();
        }
      });
    }
  }, {
    key: 'handleDeleteState',
    value: function handleDeleteState(event, round, stateIndex) {
      var _this5 = this;

      this.props.modalViewStore.setModal({
        title: 'Delete State',
        message: 'Are you sure you want to delete "' + round.teamStates[stateIndex].displayName + '"?',
        confirmLabel: 'Confirm',
        confirmBtnClass: 'green delete-a',
        cancelLabel: 'Cancel',
        cancelBtnClass: 'red times-b',
        onConfirmFunc: function onConfirmFunc() {
          _this5.deleteTeamState(event, round, stateIndex);_this5.props.modalViewStore.resetModal();
        }
      });
    }
  }, {
    key: 'handleViewSimWarnings',
    value: function handleViewSimWarnings(warnings) {
      this.props.modalViewStore.setModal({
        title: 'View Simulation Error(s)',
        message: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'sub-title' },
            'The following issues must be fixed before you can view this simulation:'
          ),
          _react2.default.createElement(
            'div',
            { className: "warnings" },
            warnings.map(function (warning) {
              return _react2.default.createElement(
                'div',
                { className: "warning" },
                warning
              );
            })
          )
        ),
        confirmLabel: 'OK',
        confirmBtnClass: 'red'
      });
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var _this6 = this;

      var map = (0, _keys2.default)(this.tasks).reduce(function (acc, id) {
        if (!_this6.tasks[id].activity) return acc;
        acc[id] = {
          id: id,
          contentModel: _this6.tasks[id],
          viewMode: "linear-editor"
        };
        return acc;
      }, {});

      if (this.simulation && this.simulation.shell) {
        map["edit" + this.simulation.shell.id] = {
          id: "edit" + this.simulation.shell.id,
          contentModel: this.simulation.shell,
          Component: this.simulation.shell.Editor
        };
        map[this.simulation.id] = {
          id: this.simulation.id,
          contentModel: this.simulation
        };
      }

      return map;
    }
  }]);

  function FlowEditorViewStore() {
    (0, _classCallCheck3.default)(this, FlowEditorViewStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FlowEditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(FlowEditorViewStore)).apply(this, arguments));

    _initDefineProp(_this, 'devMode', _descriptor, _this);

    _initDefineProp(_this, 'viewModeExpanded', _descriptor2, _this);

    _initDefineProp(_this, 'activeRoundTracker', _descriptor3, _this);

    _initDefineProp(_this, 'taskPickerActive', _descriptor4, _this);

    _initDefineProp(_this, 'taskPickerRoundObj', _descriptor5, _this);

    _initDefineProp(_this, 'taskPickerStateObj', _descriptor6, _this);

    _initDefineProp(_this, 'taskPickerStateIndex', _descriptor7, _this);

    _initDefineProp(_this, 'taskPickerRoundIndex', _descriptor8, _this);

    _initDefineProp(_this, 'taskPickerActiveTask', _descriptor9, _this);

    _initDefineProp(_this, 'taskPickerViewOnlyMode', _descriptor10, _this);

    _initDefineProp(_this, 'taskPickerNewTaskBuilderActive', _descriptor11, _this);

    _initDefineProp(_this, 'taskPickerNewTaskType', _descriptor12, _this);

    _initDefineProp(_this, 'taskPickerNewTaskTitle', _descriptor13, _this);

    _initDefineProp(_this, 'taskPickerNewTaskDescription', _descriptor14, _this);

    _initDefineProp(_this, 'taskPickerQue', _descriptor15, _this);

    _initDefineProp(_this, 'taskPickerSearchFilter', _descriptor16, _this);

    _initDefineProp(_this, 'activityManagerActive', _descriptor17, _this);

    _this.dispose = [];

    _initDefineProp(_this, 'simulation', _descriptor18, _this);

    _this.teamStateViewModel = {
      collapsed: false
    };
    _this.teamStatesState = _mobx.observable.map(window.localStorage.getItem("teamStatesState") ? JSON.parse(window.localStorage.getItem("teamStatesState")) : {});

    _initDefineProp(_this, 'inEditNameMode', _descriptor19, _this);

    _initDefineProp(_this, 'simPreviewActionsCollapsed', _descriptor20, _this);

    var project = _this.props.contentModel;

    var sim = project.children.find(function (ent) {
      return !ent.hasBrokenChildren;
    });

    if (!sim) _this.newSimulation();else _this.selectSimulation(sim.id);

    // makes sure there is a local view representation for each teamstate, always
    _this.dispose.push((0, _mobx.autorun)(function () {
      _this.teamStates.forEach(function (ts) {
        if (!_this.teamStatesState.get(ts.id)) _this.teamStatesState.set(ts.id, _this.teamStateViewModel);
      });
    }));

    //trims localstorage if it has no-longer-existing teamstates
    _this.dispose.push((0, _mobx.when)(function () {
      return _this.teamStates.length;
    }, function () {
      var orphans = _this.teamStatesState.keys().filter(function (k) {
        return !_this.teamStates.find(function (ts) {
          return k === ts.id;
        });
      });
      if (orphans.length) {
        orphans.forEach(function (k) {
          return _this.teamStatesState.delete(k);
        });
        _this.saveTeamStatesState();
      }
    }));

    _this.dispose.push((0, _mobx.autorun)(function () {
      if (_this.taskPickerActiveTask) _this.selectView(_this.taskPickerActiveTask);else _this.clearView();
    }));
    return _this;
  }

  (0, _createClass3.default)(FlowEditorViewStore, [{
    key: 'devMsg',
    value: function devMsg(msg) {
      if (this.devMode === true) {
        console.log(msg);
      }
    }
  }, {
    key: 'newTask',
    value: function newTask() {
      var cm = this.props.contentModel;
      var rnd = Math.floor(Math.random() * 1000000000 + 100000);
      var id = 'task_' + rnd; // Need to refactor the "guid"" or "id" creation, this is temporary
      var ret = new _taskEntity.ContentModel({
        "id": id,
        "activityType": cm.$parent.entities.get(this.taskPickerNewTaskType),
        "displayTitle": this.taskPickerNewTaskTitle,
        "description": this.taskPickerNewTaskDescription,
        "required": false,
        "addImmediately": true
      });
      ret.activity = new ret.activityType.module.ContentModel({ id: 'activity_' + rnd });
      ret.saveEntity();
      ret.activity.saveEntity();
      return ret;
    }
  }, {
    key: 'newRound',
    value: function newRound() {
      return new _roundEntity.ContentModel({
        id: 'round-' + Math.floor(Math.random() * 1000000000 + 100000), // Need to refactor the "guid"" or "id" creation, this is temporary
        displayName: "New Round (" + (this.simulation.rounds.length + 1) + ')',
        beginTime: 0,
        endTime: 0,
        userNotes: "Enter Notes Here..."
      });
    }
  }, {
    key: 'newTeamState',
    value: function newTeamState(round) {
      // Need to refactor the "guid"" or "id" creation, this is temporary
      return new _teamstateEntity.ContentModel({
        id: "state_" + Math.floor(Math.random() * 1000000000 + 100000),
        displayName: "New State (" + (round.teamStates.length + 1) + ')',
        isWaitState: false
      });
    }
  }, {
    key: 'quickNavToRound',
    value: function quickNavToRound(event, roundIndex) {
      if ($('.flow-editor .workspace-container .workspace .round-wrapper').length) {
        var desiredRound = $('.flow-editor .workspace-container .workspace .round-wrapper:nth-child(' + (roundIndex + 1) + ')');
        var currentScrollOffset = $('.flow-editor .workspace-container .workspace').offset().left;
        var scrollVal = desiredRound.offset().left - currentScrollOffset - 10;
        $('.flow-editor .workspace-container').animate({ scrollLeft: scrollVal }, 300);
        setTimeout(function () {
          desiredRound.addClass('flash');
        }, 200);
        setTimeout(function () {
          desiredRound.removeClass('flash');
        }, 500);
      }
    }
  }, {
    key: 'scrollToNewRound',
    value: function scrollToNewRound() {
      if ($('.flow-editor .workspace-container .workspace .round-wrapper').length) {
        var newRound = $('.flow-editor .workspace-container .workspace .round-wrapper:last-child');
        var currentScrollOffset = this.currentWorkspaceScrollOffset();
        var scrollHere = newRound.offset().left - currentScrollOffset + newRound.outerWidth();
        $('.flow-editor .workspace-container').animate({ scrollLeft: scrollHere }, 300);
      }
    }
  }, {
    key: 'selectActiveRoundQuickNavBasedOnRoundHover',
    value: function selectActiveRoundQuickNavBasedOnRoundHover(event, roundIndex, eventType) {
      if ($('.flow-editor .quick-navigation .item').length) {
        var targetedRound = $('.flow-editor .quick-navigation .item:nth-child(' + (roundIndex + 1) + ')');
        if (eventType === 'enter') {
          targetedRound.addClass('highlight');
          this.activeRoundTracker = roundIndex + 1;
        } else if (eventType === 'leave') {
          targetedRound.removeClass('highlight');
        }
      }
    }
  }, {
    key: 'selectActiveRoundQuickNav',
    value: function selectActiveRoundQuickNav(event, roundIndex, eventType) {
      if ($('.flow-editor .workspace-container .workspace .round-wrapper').length) {
        var targetedRound = $('.flow-editor .workspace-container .workspace .round-wrapper:nth-child(' + (roundIndex + 1) + ')');
        if (eventType === 'enter') {
          targetedRound.addClass('highlight-selected');
          //this.activeRoundTracker = roundIndex + 1;
        } else if (eventType === 'leave') {
          targetedRound.removeClass('highlight-selected');
        }
      }
    }
  }, {
    key: 'toggleWorkspaceViewMode',
    value: function toggleWorkspaceViewMode() {
      var self = this;
      if (this.viewModeExpanded === false) {
        $('body').addClass('expanded-view');
        var roundTarget = $('.flow-editor .workspace-container .workspace .round-wrapper:nth-child(' + self.activeRoundTracker + ')');
        var currentScrollOffset = self.currentWorkspaceScrollOffset();
        var scrollHere = roundTarget.offset().left - currentScrollOffset;
        $('.flow-editor .workspace-container').animate({ scrollLeft: scrollHere - 10 }, 0);
      } else if (this.viewModeExpanded === true) {
        $('body').removeClass('expanded-view');
      }
    }
  }, {
    key: 'currentWorkspaceScrollOffset',
    value: function currentWorkspaceScrollOffset() {
      if ($('.flow-editor .workspace-container .workspace').length) {
        return $('.flow-editor .workspace-container .workspace').offset().left;
      } else {
        return 0;
      }
    }
  }, {
    key: 'currentPoolOffset',
    value: function currentPoolOffset() {
      if ($('.task-picker .pool').length) {
        console.log($('.task-picker .pool').offset().top);
        return $('.task-picker .pool').offset().top;
      } else {
        return 0;
      }
    }
  }, {
    key: 'scrollToNewTask',
    value: function scrollToNewTask() {
      if ($('.task-picker .pool .task').length) {
        var newTask = $('.task-picker .pool .task:last-child');
        var currentScrollOffset = this.currentPoolOffset();
        var scrollHere = newTask.offset().top + currentScrollOffset + newTask.outerHeight();
        $('.task-picker .pool').animate({ scrollTop: scrollHere }, 300);
      }
    }
  }, {
    key: 'scrollToNewState',
    value: function scrollToNewState(roundIndex) {
      if ($('.round-wrapper .round').length) {
        var round = $('.round-wrapper:nth-child(' + (roundIndex + 1) + ')' + ' ' + '.round');
        round.animate({ scrollTop: round[0].scrollHeight }, 300);
      }
    }
  }, {
    key: 'move',
    value: function move(array, from, to) {
      if (to === from) return array;
      var target = array[from];
      var increment = to < from ? -1 : 1;
      for (var k = from; k != to; k += increment) {
        array[k] = array[k + increment];
      }
      array[to] = target;
      return array;
    }
  }, {
    key: 'toggleViewMode',
    value: function toggleViewMode() {
      if (this.viewModeExpanded === true) {
        this.viewModeExpanded = false;
      } else if (this.viewModeExpanded === false) {
        this.viewModeExpanded = true;
      }
      this.toggleWorkspaceViewMode();
      this.devMsg('Toggled: View Mode');
    }
  }, {
    key: 'deleteAllRounds',
    value: function deleteAllRounds() {
      this.simulation.rounds = [];
      this.devMsg('Deleted: All Rounds');
    }
  }, {
    key: 'deleteTeamState',
    value: function deleteTeamState(event, round, stateIndex) {
      round.teamStates.splice(stateIndex, 1);
      this.devMsg('Deleted: Team State');
    }
  }, {
    key: 'createNewRound',
    value: function createNewRound() {
      var self = this;
      this.simulation.rounds.push(this.newRound());
      this.scrollToNewRound();
      this.devMsg('Created: New Round');
    }
  }, {
    key: 'addNewTeamState',
    value: function addNewTeamState(event, round, roundIndex) {
      round.teamStates.push(this.newTeamState(round));
      this.scrollToNewState(roundIndex);
      this.devMsg('Added: Team State');
    }
  }, {
    key: 'updateRoundBeginTime',
    value: function updateRoundBeginTime(event, round) {
      round.beginTime = event.target.value;
      this.devMsg('Updated: Round Begin Time');
    }
  }, {
    key: 'updateRoundEndTime',
    value: function updateRoundEndTime(event, round) {
      round.endTime = event.target.value;
      this.devMsg('Updated: Round End Time');
    }
  }, {
    key: 'updateRoundDisplayName',
    value: function updateRoundDisplayName(event, round) {
      round.displayName = event.target.value;
      this.devMsg('Updated: Round Display Name');
    }
  }, {
    key: 'updateRoundNotes',
    value: function updateRoundNotes(event, round) {
      round.userNotes = event.target.value;
      this.devMsg('Updated: Round Notes');
    }
  }, {
    key: 'updateTeamStateDisplayName',
    value: function updateTeamStateDisplayName(event, state) {
      state.displayName = event.target.value;
      this.devMsg('Updated: State Name');
    }
  }, {
    key: 'updateTaskRequired',
    value: function updateTaskRequired(event, task) {
      if (task.required === true) {
        task.required = false;
      } else if (task.required === false) {
        task.required = true;
      }
      this.devMsg('Updated: Task Required');
    }
  }, {
    key: 'deleteTaskFromTeamState',
    value: function deleteTaskFromTeamState(event, state, taskIndex) {
      state.tasks.splice(taskIndex, 1);
      this.devMsg('Deleted: Team State');
    }
  }, {
    key: 'deleteRound',
    value: function deleteRound(event, roundIndex) {
      this.simulation.rounds.splice(roundIndex, 1);
      this.devMsg('Deleted: Round');
    }
  }, {
    key: 'reorderItem',
    value: function reorderItem(targetArray, oldIndex, newIndex) {
      var updatedArr = this.move(targetArray.slice(), oldIndex, newIndex);
      targetArray.replace(updatedArr);
      this.devMsg('Moved: Round, State or Task');
    }
  }, {
    key: 'toggleTeamStateCollapse',
    value: function toggleTeamStateCollapse(event, state) {
      var tsState = this.teamStatesState.get(state.id);
      if (tsState.collapsed === true) {
        tsState.collapsed = false;
        this.devMsg('Opened: State');
      } else if (tsState.collapsed === false) {
        tsState.collapsed = true;
        this.devMsg('Closed: State');
      }
      this.saveTeamStatesState();
    }
  }, {
    key: 'enableActivityManager',
    value: function enableActivityManager(event) {
      if (this.taskPickerActive !== true) {
        this.taskPickerActive = true;
        this.activityManagerActive = true;
      }
    }
  }, {
    key: 'resetTaskPicker',
    value: function resetTaskPicker() {
      var self = this;
      this.taskPickerActive = false;
      setTimeout(function () {
        self.taskPickerViewOnlyMode = false;
        self.taskPickerNewTaskBuilderActive = false;
        self.activityManagerActive = false;
        self.taskPickerRoundObj = null;
        self.taskPickerStateObj = null;
        self.taskPickerStateIndex = null;
        self.taskPickerRoundIndex = null;
        self.taskPickerActiveTask = null;
        self.taskPickerQue = [];
        self.taskPickerNewTaskType = '';
        self.taskPickerNewTaskTitle = '';
        self.taskPickerNewTaskDescription = '';
        self.taskPickerSearchFilter = '';
      }, 500);
      this.devMsg('Task Picker: State Reset');
    }
  }, {
    key: 'addTaskToSelectedState',
    value: function addTaskToSelectedState(event, state, round, stateIndex, roundIndex) {
      if (this.taskPickerActive !== true) {
        this.taskPickerRoundObj = round;
        this.taskPickerStateObj = state;
        this.taskPickerActive = true;
        this.taskPickerStateIndex = stateIndex;
        this.taskPickerRoundIndex = roundIndex;
        console.log('Round Index: ' + roundIndex);
        console.log('State Index: ' + stateIndex);
        this.devMsg('Added: State Context To Task Picker');
      }
    }
  }, {
    key: 'closeTaskPicker',
    value: function closeTaskPicker(event) {
      if (this.taskPickerActive !== false) {
        this.resetTaskPicker();
        this.devMsg('Closed: Task Picker');
      }
    }
  }, {
    key: 'addTaskToQue',
    value: function addTaskToQue(task) {
      var taskIndex = this.taskPickerQue.indexOf(task);
      if (taskIndex > -1) {
        this.taskPickerQue.splice(taskIndex, 1);
      } else {
        this.taskPickerQue.push(task);
      }
      this.devMsg('Added: Task To Que' + '"' + task + '"');
    }
  }, {
    key: 'removeTaskFromQue',
    value: function removeTaskFromQue(task) {
      var taskIndex = this.taskPickerQue.indexOf(task);
      if (taskIndex !== -1) {
        this.taskPickerQue.splice(taskIndex, 1);
      }
      this.devMsg('Removed: Task From Que' + '"' + task + '"');
    }
  }, {
    key: 'highlightTasksAddedToState',
    value: function highlightTasksAddedToState() {
      var roundIndex = this.taskPickerRoundIndex + 1;
      var stateIndex = this.taskPickerStateIndex + 1;
      var tasks = this.taskPickerQue.length;
      var state = $('.round-wrapper:nth-child(' + roundIndex + ')' + ' > .round').find('.team-state:nth-child(' + stateIndex + ')');

      function highlightNewTasks(actionType) {
        var amountOfTasks = state.find('.tasks > .task').length;
        var action;
        var cn = 'just-added';
        if (actionType === 'add') {
          // A dynamic solution should be implemented in the long term. Right now it is static and acount for up to 10 items
          if (tasks >= 1) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 1) + ')').addClass(cn);
          }
          if (tasks >= 2) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 2) + ')').addClass(cn);
          }
          if (tasks >= 3) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 3) + ')').addClass(cn);
          }
          if (tasks >= 4) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 4) + ')').addClass(cn);
          }
          if (tasks >= 5) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 5) + ')').addClass(cn);
          }
          if (tasks >= 6) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 6) + ')').addClass(cn);
          }
          if (tasks >= 7) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 7) + ')').addClass(cn);
          }
          if (tasks >= 8) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 8) + ')').addClass(cn);
          }
          if (tasks >= 9) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 9) + ')').addClass(cn);
          }
          if (tasks >= 10) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 10) + ')').addClass(cn);
          }
        } else if (actionType === 'remove') {
          if (tasks >= 1) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 1) + ')').removeClass(cn);
          }
          if (tasks >= 2) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 2) + ')').removeClass(cn);
          }
          if (tasks >= 3) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 3) + ')').removeClass(cn);
          }
          if (tasks >= 4) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 4) + ')').removeClass(cn);
          }
          if (tasks >= 5) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 5) + ')').removeClass(cn);
          }
          if (tasks >= 6) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 6) + ')').removeClass(cn);
          }
          if (tasks >= 7) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 7) + ')').removeClass(cn);
          }
          if (tasks >= 8) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 8) + ')').removeClass(cn);
          }
          if (tasks >= 9) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 9) + ')').removeClass(cn);
          }
          if (tasks >= 10) {
            state.find('.tasks > .task:nth-child(' + (amountOfTasks - tasks + 10) + ')').removeClass(cn);
          }
        }
      }

      setTimeout(function () {
        highlightNewTasks('add');
      }, 200);

      setTimeout(function () {
        highlightNewTasks('remove');
      }, 1400);
    }
  }, {
    key: 'addSelectedTasksToState',
    value: function addSelectedTasksToState() {
      console.log(this.taskPickerRoundObj);
      console.log(this.taskPickerStateObj);
      for (var i = 0; i < this.taskPickerQue.length; i++) {
        this.taskPickerStateObj.tasks.push(this.tasks[this.taskPickerQue[i]]);
      }
      this.highlightTasksAddedToState();
      this.resetTaskPicker();
      this.devMsg('Added: Selected Task(s) To State');
    }
  }, {
    key: 'viewTaskInTaskPicker',
    value: function viewTaskInTaskPicker(taskKey) {
      var _this7 = this;

      if (this.taskPickerActiveTask === taskKey) return;
      var editorViewStore = this.props.editorViewStore;

      var openTask = function openTask() {
        _this7.taskPickerNewTaskType = '';
        _this7.taskPickerNewTaskTitle = '';
        _this7.taskPickerNewTaskDescription = '';
        _this7.taskPickerNewTaskBuilderActive = false;
        _this7.taskPickerActiveTask = taskKey;
        _this7.devMsg('Viewing: Task [' + taskKey + ']');
      };

      if (editorViewStore.isEditorOpen) {
        editorViewStore.startEditing({
          contentModel: this.tasks[taskKey].activity,
          whenNotDirty: openTask
        });
      } else {
        openTask();
      }
    }
  }, {
    key: 'viewTaskPreview',
    value: function viewTaskPreview(event, state, round, task) {
      console.log(task);
      this.taskPickerRoundObj = round;
      this.taskPickerStateObj = state;
      this.taskPickerActiveTask = task.id;
      this.taskPickerActive = true;
      this.taskPickerViewOnlyMode = true;
      this.devMsg('Viewing: Task Preview [' + task.id + ']');
    }
  }, {
    key: 'createNewTask',
    value: function createNewTask() {
      this.taskPickerNewTaskBuilderActive = true;
      this.taskPickerActiveTask = null;
      this.devMsg('Task Creator: Active');
    }
  }, {
    key: 'cancelTaskCreation',
    value: function cancelTaskCreation() {
      this.taskPickerNewTaskBuilderActive = false;
      this.taskPickerActiveTask = null;
      this.devMsg('Canceled: Task Creation');
    }
  }, {
    key: 'createSelectedTask',
    value: function createSelectedTask() {
      var newTask = this.newTask();
      this.tasks[newTask.id] = newTask;
      this.taskPickerNewTaskType = '';
      this.taskPickerNewTaskTitle = '';
      this.taskPickerNewTaskDescription = '';
      this.taskPickerNewTaskBuilderActive = false;
      this.taskPickerActiveTask = newTask.id;
      this.scrollToNewTask();
      this.devMsg('Created: New Task');
    }
  }, {
    key: 'updateNewTaskType',
    value: function updateNewTaskType(event) {
      this.taskPickerNewTaskType = event.target.value;;
      this.devMsg('Updated: New Task Type');
    }
  }, {
    key: 'updateNewTaskDisplayTitle',
    value: function updateNewTaskDisplayTitle(event) {
      this.taskPickerNewTaskTitle = event.target.value;
      this.devMsg('Updated: New Task Title');
    }
  }, {
    key: 'updateNewTaskDescription',
    value: function updateNewTaskDescription(event) {
      this.taskPickerNewTaskDescription = event.target.value;
      this.devMsg('Updated: New Task Description');
    }
  }, {
    key: 'updateTaskPickerSearchFilter',
    value: function updateTaskPickerSearchFilter(event) {
      this.taskPickerSearchFilter = event.target.value;
      this.devMsg('Updated: Task Picker Search Filter');
    }
  }, {
    key: 'saveSimulation',
    value: function saveSimulation() {
      this.simulation.allEntities.forEach(function (ent) {
        return ent.saveEntity(null, function (err) {
          return alert(ent.id + " did not save!" + err);
        });
      });
    }
  }, {
    key: 'revertSimulation',
    value: function revertSimulation() {
      this.simulation.allEntities.forEach(function (ent) {
        return ent.revert();
      });
    }
  }, {
    key: 'selectSimulation',
    value: function selectSimulation(id) {
      if (id === "_new") return this.newSimulation();
      this.simulation = this.simulations.find(function (s) {
        return s.id === id;
      });
    }
  }, {
    key: 'newSimulation',
    value: function newSimulation() {
      var project = this.props.contentModel;

      var id = 'simulation_' + Math.floor(Math.random() * 1000000000 + 100000); // Need to refactor the "guid"" or "id" creation, this is temporary
      project.children.push(new _simulationEntity.ContentModel({
        id: id,
        "displayName": 'New Simulation (' + (this.simulations.length + 1) + ')'
      }));
      project.saveEntity();
      this.selectSimulation(id);
    }
  }, {
    key: 'saveTeamStatesState',
    value: function saveTeamStatesState() {
      window.localStorage.setItem("teamStatesState", (0, _stringify2.default)(this.teamStatesState.toJS()));
    }
  }, {
    key: 'toggleEditNameMode',
    value: function toggleEditNameMode() {
      this.inEditNameMode = !this.inEditNameMode;
    }
  }, {
    key: 'toggleSimPreviewActions',
    value: function toggleSimPreviewActions() {
      if (this.simPreviewActionsCollapsed === false) {
        this.simPreviewActionsCollapsed = true;
      } else if (this.simPreviewActionsCollapsed === true) {
        this.simPreviewActionsCollapsed = false;
      }
    }
  }, {
    key: 'project',
    get: function get() {
      var project = this.props.contentModel;

      return project;
    }
  }, {
    key: 'simulations',
    get: function get() {
      return this.project.children.filter(function (ent) {
        return !ent.hasBrokenChildren;
      });
    }
  }, {
    key: 'teamStates',
    get: function get() {
      return this.project.children.length ? this.project.children.reduce(function (acc, simulation) {
        return acc.concat(simulation.rounds.reduce(function (acc2, rnd) {
          return acc2.concat(rnd.teamStates.slice());
        }, []));
      }, []) : [];
    }
  }, {
    key: 'tasks',
    get: function get() {
      var type = this.project.$parent.entities.get("TaskContentModel");
      return type.entities.filter(function (ent) {
        return !ent.hasBrokenChildren;
      }).reduce(function (acc, t) {
        acc[t.id] = t;return acc;
      }, {});
    }
  }, {
    key: 'componentList',
    get: function get() {
      var type = this.project.$parent.entities.get("RegisteredActivityContentModel");
      return type.entities.map(function (ent) {
        return ent.id;
      });
    }
  }, {
    key: 'selectedTask',
    get: function get() {
      return this.taskPickerActiveTask && this.tasks[this.taskPickerActiveTask];
    }
  }, {
    key: 'SelectedTaskActivity',
    get: function get() {
      return this.selectedTask.activity.Component || this.selectedTask.activity.FullEditor || this.selectedTask.activity.Editor;
    }
  }]);
  return FlowEditorViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'devMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'viewModeExpanded', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'activeRoundTracker', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerRoundObj', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerStateObj', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerStateIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerRoundIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerActiveTask', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerViewOnlyMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskBuilderActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskType', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskTitle', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerNewTaskDescription', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerQue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, 'taskPickerSearchFilter', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, 'activityManagerActive', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'handleDeleteRound', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleDeleteRound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'permanentlyDeleteTask', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'permanentlyDeleteTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cloneTask', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cloneTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleDeleteAllRounds', [_dec4], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleDeleteAllRounds'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleDeleteState', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleDeleteState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleViewSimWarnings', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'handleViewSimWarnings'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'project', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'project'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'simulations', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'simulations'), _class.prototype), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, 'simulation', [_dec7], {
  enumerable: true,
  initializer: function initializer() {
    return { displayName: "", id: "", rounds: [], allChildEntities: [], publishWarnings: [], warnings: [] };
  }
}), _applyDecoratedDescriptor(_class.prototype, 'teamStates', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'teamStates'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tasks', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tasks'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'componentList', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'componentList'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'move', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'move'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleViewMode', [_dec9], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleViewMode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteAllRounds', [_dec10], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteAllRounds'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteTeamState', [_dec11], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteTeamState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createNewRound', [_dec12], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createNewRound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addNewTeamState', [_dec13], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addNewTeamState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundBeginTime', [_dec14], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundBeginTime'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundEndTime', [_dec15], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundEndTime'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundDisplayName', [_dec16], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateRoundNotes', [_dec17], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateRoundNotes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateTeamStateDisplayName', [_dec18], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateTeamStateDisplayName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateTaskRequired', [_dec19], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateTaskRequired'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteTaskFromTeamState', [_dec20], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteTaskFromTeamState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteRound', [_dec21], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteRound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reorderItem', [_dec22], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'reorderItem'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleTeamStateCollapse', [_dec23], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleTeamStateCollapse'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'enableActivityManager', [_dec24], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'enableActivityManager'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetTaskPicker', [_dec25], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'resetTaskPicker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addTaskToSelectedState', [_dec26], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addTaskToSelectedState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeTaskPicker', [_dec27], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'closeTaskPicker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addTaskToQue', [_dec28], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addTaskToQue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeTaskFromQue', [_dec29], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeTaskFromQue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addSelectedTasksToState', [_dec30], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'addSelectedTasksToState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewTaskInTaskPicker', [_dec31], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewTaskInTaskPicker'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'viewTaskPreview', [_dec32], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewTaskPreview'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createNewTask', [_dec33], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createNewTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cancelTaskCreation', [_dec34], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancelTaskCreation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'createSelectedTask', [_dec35], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'createSelectedTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateNewTaskType', [_dec36], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateNewTaskType'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateNewTaskDisplayTitle', [_dec37], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateNewTaskDisplayTitle'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateNewTaskDescription', [_dec38], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateNewTaskDescription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateTaskPickerSearchFilter', [_dec39], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateTaskPickerSearchFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectedTask', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectedTask'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'SelectedTaskActivity', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'SelectedTaskActivity'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveSimulation', [_dec40], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'revertSimulation', [_dec41], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'revertSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectSimulation', [_dec42], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'newSimulation', [_dec43], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'newSimulation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'saveTeamStatesState', [_dec44], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'saveTeamStatesState'), _class.prototype), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, 'inEditNameMode', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'toggleEditNameMode', [_dec45], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleEditNameMode'), _class.prototype), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, 'simPreviewActionsCollapsed', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'toggleSimPreviewActions', [_dec46], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleSimPreviewActions'), _class.prototype)), _class));
var _default = FlowEditorViewStore;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(FlowEditorViewStore, 'FlowEditorViewStore', 'src/entity_modules/project-entity/editor-viewstore.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/entity_modules/project-entity/editor-viewstore.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/entity_modules/project-entity/editor-viewstore.js
// module id = ./node_modules/platform-client-bootstrap/dist/entity_modules/project-entity/editor-viewstore.js
// module chunks = 0